import { gql, TypedDocumentNode } from '@apollo/client';
import { WalletTypeEnum } from '@libs/backend-common';
import { DefaultApiResponse, DefaultArg, walletFragment } from '@libs/graphql';
import { HistoryPeriodEnumKeys, WalletInfoItem } from '@libs/types';

export type GetWalletInfoDetailedNewArgs = {
  isCrypto?: boolean;
  walletType?: WalletTypeEnum;
  valueAssetCode?: string;
  assetCode?: string;
  sortByCmcRank?: boolean;
  skip?: number;
  take?: number;
};
export type WalletItemChangeDetails = {
  valueChangeAmount: string;
  rateChangeAmount: string;
  valueChangePercentage: string;
  rateChangePercentage: string;
};
export type WalletInfoDetailed = WalletInfoItem & {
  changeDetails: WalletItemChangeDetails;
  totalValue: string;
};
export type GetWalletInfoDetailedResponse = {
  getWalletInfoDetailed: DefaultApiResponse<WalletInfoDetailed[]>;
};

type WalletAdditionalArgs = {
  changeDetailsRecord: {
    period: HistoryPeriodEnumKeys;
    valueAssetCode: string;
  };
};
export const getWalletInfoDetailedQuery: TypedDocumentNode<
  GetWalletInfoDetailedResponse,
  DefaultArg<GetWalletInfoDetailedNewArgs> & WalletAdditionalArgs
> = gql`
  query GetWalletInfoNew(
    $record: GetWalletNewRecord!
    $changeDetailsRecord: AssetsRateChangeRecord!
  ) {
    getWalletInfoDetailed: getWalletInfoNew(record: $record) {
      ...walletFields
      changeDetails(record: $changeDetailsRecord) {
        valueChangeAmount
        valueChangePercentage
        rateChangePercentage
        rateChangeAmount
      }
      orderingPriority
      totalValue
    }
  }

  ${walletFragment}
`;
